export default "data:image/gif;base64,R0lGODlhAgABAIACAAAeV1nE0iH+EUNyZWF0ZWQgd2l0aCBHSU1QACwAAAAAAgABAAACAkQKADs="